import React, { Component } from 'react';
import styled from 'styled-components';
import GenrePicker from './GenrePicker';

const nameRegExp = new RegExp('^[a-zA-Z0-9\\-_]*$');

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: stretch;
  justify-content: center;
  background-color: #CCC2C2;
  padding: 20px;
  height: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Logo = styled.img`
  max-width: 100%;
`;

const InputContainer = styled.div`
  margin-top: 20px;
  align-self: stretch;
  height: 48px;
`;

const TextField = styled.input`
  text-align: center;
  font-size: 32px;
  font-family: 'lcdsolid';
  color: #555555;
  padding: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  &::placeholder {
    color: #8f888c;
  }
`;

const GenreContainer = styled.div`
  margin-top: 20px;
  align-self: stretch;
  height: 60px;
`;

const ButtonContainer = styled.div`
  padding-top: 30px;
  align-self: stretch;
  height: 96px;
  display: flex;
  justify-content: center;
`;

const PlayButton = styled.button`
  align-self: center;
  border-radius: 4px;
  background-color: #965A38;
  padding: 12px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
`;

const ButtonText = styled.span`
  font-family: 'lcdsolid';
  font-size: 24px;
  color: #D9A441;
`;

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            birthYear: '',
            genre: null,
        };
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleBirthYearChange = this.handleBirthYearChange.bind(this);
    }

    handleNameChange(event) {
        const value = event.target.value;
        if (!nameRegExp.test(value)) {
            return;
        }
        this.setState({ name: value });
    }

    handleBirthYearChange(event) {
        this.setState({ birthYear: event.target.value });
    }

    renderButton() {
        if (!this.state.name.trim() || !this.state.birthYear.trim() || !this.state.genre) {
            return null;
        }
        return (
            <PlayButton
                onClick={() => this.props.onLetsPlay(this.state.name, this.state.birthYear, this.state.genre)}
            >
                <ButtonText>Let's play</ButtonText>
            </PlayButton>
        );
    }

    render() {
        return (
            <Container>
                <ContentContainer>
                    <Logo src="/images/eyo.png" alt="Eyo Logo" />
                    
                    <InputContainer>
                        <TextField
                            placeholder="Your name"
                            maxLength={12}
                            value={this.state.name}
                            onChange={this.handleNameChange}
                        />
                    </InputContainer>
                    
                    <InputContainer>
                        <TextField
                            placeholder="Birth year"
                            type="number"
                            maxLength={4}
                            value={this.state.birthYear}
                            onChange={this.handleBirthYearChange}
                        />
                    </InputContainer>
                    
                    <GenreContainer>
                        <GenrePicker 
                            genre={this.state.genre} 
                            onChange={genre => this.setState({ genre })}
                        />
                    </GenreContainer>
                    
                    <ButtonContainer>
                        {this.renderButton()}
                    </ButtonContainer>
                    
                    <div style={{ height: 70 }} />
                </ContentContainer>
            </Container>
        );
    }
}
